export const getCardBaseStyles = (selected: boolean, isPressed?: boolean, disabled?: boolean) => ({
  color: disabled ? "gray.400" : "black",
  bg: disabled ? "#f5f5f5" : "white",
  border: disabled
    ? "1px solid var(--color-grey-light)"
    : selected || isPressed
    ? "2px solid var(--color-blue)"
    : "1px solid var(--color-grey-light)",
  className: `overflow-hidden shadow-md ${
    selected || isPressed ? "press-animation" : ""
  } w-full`,
});

export const getCardLayoutStyles = (type: 'square' | 'rectangle' | 'onboarding' = 'rectangle') => {
  const baseStyles = {
    rounded: "2xl",
    p: 4,
  };

  switch (type) {
    case 'square':
      return {
        ...baseStyles,
        rounded: "xl",
        minWidth: "var(--large-card-width)",
        maxWidth: "var(--large-card-width)",
        aspectRatio: 1,
      };
    case 'onboarding':
      return {
        ...baseStyles,
        width: "var(--card-width)",
        height: "var(--card-width)",
        p: 5,
      };
    default:
      return {
        ...baseStyles,
        width: "full",
        height: "auto",
        minHeight: 50,
      };
  }
};

export const getCardContentStyles = (type: 'default' | 'centered' = 'default') => ({
  className: type === 'centered' 
    ? "items-center text-center" 
    : "items-start text-start",
});

export const getTagStyles = (type: 'level' | 'progress' = 'level') => {
  const baseStyles = {
    rounded: "xl",
    width: "fit-content",
    fontSize: "var(--base-font-size-xs)",
    fontWeight: "semibold",
  };

  switch (type) {
    case 'progress':
      return {
        ...baseStyles,
        bg: "var(--color-green)",
        color: "white",
        py: "5px",
        px: "8px",
        justifyContent: "center",
        alignItems: "center",
      };
    case 'level':
      return {
        ...baseStyles,
        bg: "transparent",
        p: 0,
      };
    default:
      return baseStyles;
  }
}; 